import React from "react";

import WalletWithdrawals from "./index";

const InternationalWalletWithdrawals = () => {
  return <WalletWithdrawals creatorCountryType="international" />;
};
export default InternationalWalletWithdrawals;
